// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__JuDqd","link":"HeaderSimple_link__Ps9QF"};